var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"filled":"","items":_vm.items,"label":_vm.filter_info.label,"item-value":_vm.filter_info.type_select_option.item_value,"item-text":_vm.filter_info.type_select_option.item_text,"clearable":""},model:{value:(_vm.p_model),callback:function ($$v) {_vm.p_model=$$v},expression:"p_model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }